import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, ActivityIndicator, Picker, Platform } from 'react-native';
import { Flex, Padding, Margin, Helpers, Typo, article, button, articleItem, FontFamily, articleLists, ontWeight, Colors, appHeader, FontWeight } from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';
import ArticleItemHorizontal from '../article-item-horizontal';
import ScrollContainerView from '../scroll-container-view';
import { helpers } from '../../utils/helpers';
import PageBreak from '../page-break';
import ArticleItem from '../article-item';
import CustomImage from '../custom-image';
import getImagePath from '../../utils/image-helper';
import Cookies from "universal-cookie";
import { Mixpanel } from '../../utils/mixpanel';
import AuthenticationWrapper from '../authentication-wrapper';
import ArticleTopStories from '../article-item-vertical/index-top-stories';
import ArticleSpecificIndexStories from '../article-item-vertical/article-verticle-specific-index';

const viewMore = getImagePath('icons/view-more.png');
const cookies = new Cookies();

export class HomeLatestStory extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        const { isAuthenticated, fetchToken } = this.props.auth
        let token = webView ? (process.browser ? (isAuthenticated ? fetchToken : false) : this.props.token) : this.props.user?.userData?.data?.token;
        this.state = {
            showToken: (!helpers.isWeb() || process.browser) ? true : false,
            selectedTab: 'Today',
        }
    }

    componentDidMount = () => {
        const {data} = this.props;
        let TodayStoryData = []
        data && data.map((item, index) => {
            if ((item.published_date.split(" ")[0]) == new Date().toISOString().split('T')[0]) {
                TodayStoryData.push(item)
            }
        });
        if(TodayStoryData.length === 0){
            this.setState({selectedTab: "This Week"});
        }
    }

    viewMoreArticles = () => {
        const { viewAllArticles } = this.props;
        viewAllArticles()
    }

    viewArticle = (catSlug, slug, postData) => {
        const { viewArticle } = this.props;
        viewArticle(catSlug, slug, postData)
    }

    viewAuthor = (slug) => {
        const { viewAuthor } = this.props;
        viewAuthor(slug)
    }
    viewCategory = (slug) => {
        const { viewCategory } = this.props;
        viewCategory(slug)
    }

    handleClick = (title, data, index) => {
        try {
            if (this.props.trackStoryClick) {
                this.props.trackStoryClick(title, data, index);
            }
        }
        catch (error) {
            console.log("check mix panel track error ==>", error);
        }
    }

    trackViewAll = () => {
        try {
            Mixpanel.track('click_view_more_latest');
        }
        catch (error) {

        }
    }

    trackCateoryClick = (item) => {
        // try {
        //     Mixpanel.track('category', {category_slug: item.category.slug, source_section_type: 'home_latest_stories', section_value: { title : item.name, slug: item.slug } });
        // }
        // catch(error) {
        //     console.log("mix panel error =>", error);
        // }
    }

    setTab = (slug) => {
        this.setState({ selectedTab: slug });
    };


    render() {
        const { data, darkMode } = this.props;
        const { selectedTab } = this.state;
        let btnClick, btnClickCategory;
        let webView = helpers.isWeb();
        let TodayStoryData = []
        data && data.map((item, index) => {
            if ((item.published_date.split(" ")[0]) == new Date().toISOString().split('T')[0]) {
                TodayStoryData.push(item)
            }
        })
        if (helpers.isWeb()) {
            btnClick = {
                to: "/all-stories"
            };

        } else {
            btnClick = {
                onPress: () => this.viewMoreArticles()
            }
        }
        let viewAllBtn;
        if (helpers.isWeb()) {
            viewAllBtn = {
                to: selectedTab === 'Today' ? '/all-stories' : '/last-week'
            }
        } else {
            viewAllBtn = {
                onPress: () => this.props.navigateApp(selectedTab === 'Today' ? '/all-stories' : '/last-week')
            }
        }
        return (

            <View style={[helpers.isDesktop() && Padding.ph_2, Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWebFull, helpers.isDesktop() && { marginTop: 40 }, !helpers.isDesktop() && { paddingBottom: 0 }, darkMode && { backgroundColor: Colors.darkBlackColorBg }]}>
                <View style={[article.headerWrapper, helpers.isDesktop() && Margin.mb_3]}>
                    {!helpers.isDesktop() && (
                        <View style={[appHeader.trendingWrapper, { alignSelf: 'center' }]}>
                            <Text
                                style={[
                                    { fontFamily: FontFamily.abrilFatface },
                                    { fontSize: 34, color: !helpers.isDesktop() ? "#051462" : "#000", fontWeight: "400" },
                                    { width: helpers.isWeb() ? "fit-content" : "100%" },
                                    darkMode && { color: "rgba(255,255,255,0.87)" },
                                ]}
                            >
                                Latest Stories
                            </Text>
                        </View>
                    )}
                    <View style={[{ flexDirection: 'row' }, !helpers.isDesktop() && { alignSelf: 'center' }]}>
                        {helpers.isDesktop() && (
                            <View style={[Flex.alignStart]}>
                                <View style={[appHeader.trendingWrapper]}>
                                    <Text
                                        style={[
                                            { fontFamily: FontFamily.abrilFatface },
                                            { fontSize: helpers.isDesktop() ? 30 : 20, color: "#000", fontWeight: "400" },
                                            { width: helpers.isWeb() ? "fit-content" : "100%" },
                                            darkMode && { color: "rgba(255,255,255,0.87)" },
                                        ]}
                                    >
                                        Latest Stories
                                    </Text>
                                </View>
                            </View>
                        )}
                        <View style={[appHeader.trendingWrapper]}>
                            <TouchableOpacityLink
                                //   {...viewAllBtnProps}
                                handleClick={() => {
                                    this.setTab("Today");
                                }}
                            >
                                <Text
                                    style={[
                                        { fontFamily: FontFamily.abrilFatface },
                                        { fontSize: helpers.isDesktop() ? 20 : 16, color: "#000", fontWeight: "400" },
                                        {
                                            color: selectedTab == "Today" ? "#6C7AF6" : "#000",
                                            borderBottomWidth: selectedTab == "Today" ? 2 : 0,
                                            borderBottomColor:
                                                selectedTab == "Today" ? "#6C7AF6" : "#000",
                                        },
                                        { width: helpers.isWeb() ? "fit-content" : "100%" },
                                        darkMode && { color: "rgba(255,255,255,0.87)" },
                                    ]}
                                >
                                    Today
                                </Text>
                            </TouchableOpacityLink>
                        </View>
                        <View style={[appHeader.trendingWrapper]}>
                            <TouchableOpacityLink
                                //   {...viewAllBtnProps}
                                handleClick={() => {
                                    this.setTab("This Week");
                                }}
                            >
                                <Text
                                    style={[
                                        { fontFamily: FontFamily.abrilFatface },
                                        { fontSize: helpers.isDesktop() ? 20 : 16, color: "#000", fontWeight: "400" },
                                        {
                                            color: selectedTab == "This Week" ? "#6C7AF6" : "#000",
                                            borderBottomWidth: selectedTab == "This Week" ? 2 : 0,
                                            borderBottomColor:
                                                selectedTab == "This Week" ? "#6C7AF6" : "#000",
                                        },
                                        { width: helpers.isWeb() ? "fit-content" : "100%" },
                                        darkMode && { color: "rgba(255,255,255,0.87)" },
                                    ]}
                                >
                                    Last Week
                                </Text>
                            </TouchableOpacityLink>
                        </View>
                        {helpers.isDesktop() && (
                            <View style={[appHeader.trendingWrapper, { marginLeft: "auto" }]}>
                                <TouchableOpacityLink
                                    {...viewAllBtn}
                                >
                                    <Text
                                        style={[
                                            Helpers.textUppercase,
                                            {
                                                color: "#907CFF",
                                                fontSize: 18,
                                                fontFamily: FontFamily.medium,
                                                fontWeight: FontWeight.semiBold,
                                                whiteSpace: "nowrap",
                                                borderWidth: 1,
                                                borderColor: "#907CFF",
                                                paddingHorizontal: 30,
                                                paddingVertical: 10,
                                            },
                                        ]}
                                    >
                                        {selectedTab === 'Today' ? 'VIEW ALL STORIES' : 'VIEW LAST WEEK’S STORIES'}
                                    </Text>
                                </TouchableOpacityLink>
                            </View>
                        )}
                    </View>
                </View>
                <View style={[Margin.mt_1, Margin.mb_4, helpers.isDesktop() && Margin.mb_7, !helpers.isDesktop() && Padding.ph_2]}>
                    {selectedTab === 'Today' && <ArticleSpecificIndexStories data={TodayStoryData} darkMode={darkMode} />}
                    {selectedTab === 'Today' && TodayStoryData.length === 0 ?
                        <View style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: 50 }}>
                            <Text style={{ fontWeight: 700, fontSize: 22, color: '#6C7AF6', marginBottom: 20}}> Sorry, no new stories today, checkout last week stories</Text>
                        </View>
                        : ""}
                    {helpers.isDesktop() ?
                        <View style={[Flex.row, Flex.FlexWrap]}>
                            {<>
                                {data && data.slice(0, 5).map((item, index) => {

                                    // if (selectedTab === 'Today') {                                    
                                    //     // set date value for today section
                                    //     // if ((item.published_date.split(" ")[0]) == new Date().toISOString().split('T')[0]) {
                                    //         if (helpers.isWeb()) {
                                    //             btnClickCategory = {
                                    //                 to: "/category/" + item.category.slug
                                    //             }
                                    //         } else {
                                    //             btnClickCategory = {
                                    //                 onPress: () => this.viewCategory(item.category.slug)
                                    //             }
                                    //         }
                                    //         return (
                                    //             <View style={[Flex.row, Flex.FlexWrap]}>
                                    //                 {/* <TouchableOpacityLink {...btnClickCategory} handleClick={() => this.trackCateoryClick(item)}>
                                    //         <View>
                                    //             <Text style={[articleLists.badge, { width: 150, marginBottom: helpers.isDesktop() ? 15 : 10, textAlign: 'left', fontFamily: FontFamily.regular, color: '#907cff',  letterSpacing: 1, fontSize: 18 }]}>{item.category.name}</Text>
                                    //         </View>
                                    //     </TouchableOpacityLink> */}                                                
                                    //         <ArticleTopStories writers={false} home={true} latestStories={true} all={index === 0 ? true : false} viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} elmsecond={index == 1 ? true : false} exclusiveHome={true} handleClick={(title) => { this.handleClick(title, item, index) }} hideDate={true} darkMode={darkMode}  />

                                    //             </View>
                                    //         )
                                    //     // } else if (index === 0) {
                                    //     //     return (
                                    //     //         <View style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: 50 }}>
                                    //     //             <Text style={{ fontWeight: 700, fontSize: 22, color: '#6C7AF6' }}> Sorry, no new stories today, checkout last week stories</Text>
                                    //     //         </View>)
                                    //     // }
                                    // }
                                    if (selectedTab == 'This Week') {
                                        if ((item.published_date.split(" ")[0]) != new Date().toISOString().split('T')[0]) {
                                            if (helpers.isWeb()) {
                                                btnClickCategory = {
                                                    to: "/category/" + item.category.slug
                                                }
                                            } else {
                                                btnClickCategory = {
                                                    onPress: () => this.viewCategory(item.category.slug)
                                                }
                                            }
                                            return (
                                                <View style={[Flex.row, Flex.FlexWrap]}>
                                                    <ArticleTopStories writers={false} home={true} latestStories={true} all={index === 0 ? true : false} viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} elmsecond={index == 1 ? true : false} exclusiveHome={true} handleClick={(title) => { this.handleClick(title, item, index) }} hideDate={true} darkMode={darkMode} />
                                                </View>
                                            )
                                        }
                                    }
                                })}
                            </>
                            }
                        </View>
                        :
                        <View style={[Margin.mb_4, !process.browser && { overflow: 'hidden' }]}>
                            {data && data.slice(0, 4).map((item, index) => {

                                if (selectedTab == 'This Week') {
                                    if (new Date(item.published_date) !== new Date()) {
                                        return (
                                            <View style={{ marginTop: 20, marginBottom: 20 }}>
                                                <TouchableOpacityLink {...btnClickCategory} handleClick={() => this.trackCateoryClick(item)}>
                                                    <View>
                                                        <Text style={[articleLists.badge, { width: 150, marginTop: !helpers.isDesktop() ? "-18px" : 0, marginBottom: 15, textAlign: 'left', fontFamily: FontFamily.regular, color: '#907cff', fontSize: 13, lineHeight: 16, letterSpacing: 0.5 }, !helpers.isWeb() && { fontFamily: FontFamily.semiBold }]}>{item.category.name}</Text>
                                                    </View>
                                                </TouchableOpacityLink>
                                                <View style={{ marginTop: !helpers.isDesktop() ? "-32px" : 0 }}>
                                                    <ArticleItemHorizontal viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} exclusiveHome={true} handleClick={(title) => { this.handleClick(title, item, index) }} hideDate={true} darkMode={darkMode} />
                                                </View>
                                            </View>
                                        )
                                    }
                                }
                            })}
                            {/* <TouchableOpacityLink
                            {...btnClick}  handleClick={(title) => {this.trackViewAll()}}
                        >
                            <View style={[Flex.column, Flex.alignCenter,{width: 155, position:'absolute', top: 100, marginLeft: -15}]}>
                                <CustomImage
                                    source={viewMore}
                                    require={true}
                                    style={{ width: 36, height: 36, margin: 'auto' }}
                                    webStyle={{ width: 36, height: 36, margin: 'auto'}}
                                />
                                <Text style={[button.secondaryOutlineText, Margin.mr_0, {fontWeight: '500'}]}>View all articles</Text>
                            </View>
                        </TouchableOpacityLink> */}
                        </View>
                    }
                    {/* {helpers.isDesktop() &&
                        <View style={[Flex.alignCenter, Margin.mt_4, { marginTop: helpers.isDesktop() ? 50 : 40 }, helpers.isDesktop() && { marginBottom: 30}]}>
                            <TouchableOpacityLink
                                {...btnClick}  handleClick={(title) => {this.trackViewAll()}}
                            >
                                <View style={[Flex.row, Flex.alignCenter]}>
                                    <Text style={[button.secondaryOutline, helpers.isDesktop() && button.secondaryOutlineDesktop ,Margin.mr_0, {fontWeight: FontWeight.semiBold}]}>View all articles</Text>
                                </View>
                            </TouchableOpacityLink>
                        </View>
                    }*/}
                </View>
            </View>
        );
    }
}

export default AuthenticationWrapper(HomeLatestStory);
